/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  AppBar,
  Box,
  CircularProgress,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Toolbar,
  Typography,
} from "@mui/material";

const PRIMARY_COLOR = "#17165A";
const SECONDARY_COLOR = "#FFD361";
const TERTIARY_COLOR = "#FFFFFF";

import { PRODUCTS } from "../consts/products";

export const MobileStatic = () => {
  const [loading, setLoading] = useState(true);


  return (
    <Box sx={{ flexGrow: 1, backgroundColor: (loading ? PRIMARY_COLOR : TERTIARY_COLOR)  }}>
      {/* App Bar */}
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: PRIMARY_COLOR,
          color: SECONDARY_COLOR,
        }}
      >
        <Toolbar sx={{ height: "64px" }}>
          <Typography
            variant="h4"
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
              fontFamily: "Tenor Sans",
            }}
          >
            NIRAN
          </Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ height: "64px" }} />

      {/* Body */}
      <ImageList sx={{ width: "100%", margin: 0 }} cols={1} gap={1}>
          {PRODUCTS.map((product, index) => (
            <ImageListItem key={index}>
              <img
                id={`image-${index}`}
                srcSet={`${product.imageUrl}?fit=crop&auto=format&dpr=2 2x`}
                src={`${product.imageUrl}?fit=crop&auto=format`}
                alt={product.imageUrl}
                loading="lazy"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
                onLoad={() => { setLoading(false) }}
              />
              <ImageListItemBar
                sx={{
                  background:
                    "linear-gradient(to top, rgba(0,0,0,0.9) 0%, " +
                    "rgba(0,0,0,0.3) 60%, rgba(0,0,0,0) 100%)",
                }}
                title={<Box style={{ fontSize: "1rem", margin: "2rem 0.5rem 0.5rem", fontFamily: "Tenor Sans", opacity: 0.8, fontWeight: "bold", whiteSpace: "pre-wrap" }}>{product.name}</Box>}
                subtitle={<Box style={{ fontSize: "1.5rem", margin: "auto 0.5rem 0.5rem", fontFamily: "Tenor Sans", opacity: 0.8 }}>{`Size ${product.size} | $${product.price}`}</Box>}
                position="bottom"
              />
            </ImageListItem>
          ))}
        </ImageList>
      
    </Box>
  );
};
